import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Table, TableName } from '@openx/components-table/Table';
import { useTranslation } from 'react-i18next';
import { useDealInsightsContext } from '../../../../context/DealInsightsContext';
import { NoDataComponent } from '../../../shared/NoDataComponent';
import { useAudiencesTableColumns } from './hooks/useAudiencesTableColumns';
import { useAudiencesTableData } from './hooks/useAudiencesTableData';

export const AudiencesTable = () => {
  const { dealInsights, criteria, handleCriteriaChange } = useDealInsightsContext();
  const { data: rawData } = dealInsights;
  const { t } = useTranslation();
  const theme = useTheme();

  const { data, isLoading } = useAudiencesTableData();

  const { columns } = useAudiencesTableColumns({
    impressions: {
      max: rawData?.audiences.impressions_range.maximum ?? 0,
      min: rawData?.audiences.impressions_range.minimum ?? 0,
      color: theme.palette.charts.indigo,
    },
    spend: {
      max: rawData?.audiences.spend_range.maximum ?? 0,
      min: rawData?.audiences.spend_range.minimum ?? 0,
      color: theme.palette.charts.lightBlue,
    },
    avg_frequency: {
      max: rawData?.audiences.avg_frequency_range.maximum ?? 0,
      min: rawData?.audiences.avg_frequency_range.minimum ?? 0,
      color: theme.palette.charts.purple,
    },
    uniques: {
      max: rawData?.audiences.uniques_range.maximum ?? 0,
      min: rawData?.audiences.uniques_range.minimum ?? 0,
      color: theme.palette.charts.lightBlue,
    },
    viewability: {
      max: 1,
      min: 0,
      color: theme.palette.charts.pink,
    },
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          px: 4,
          pt: 4,
          pb: 1,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="h2">{t('Audiences')}</Typography>
      </Box>

      <Table
        data-test="deal-insights-audiences-table"
        data={data}
        columns={columns}
        loading={isLoading}
        criteria={criteria[TableName.DEAL_INSIGHTS_AUDIENCES]}
        name={TableName.DEAL_INSIGHTS_AUDIENCES}
        onCriteriaChange={newCriteria => handleCriteriaChange(newCriteria, TableName.DEAL_INSIGHTS_AUDIENCES)}
        overrideTableCellStyles={{ padding: 0 }}
        skeletonRows={10}
        customNoDataComponent={NoDataComponent}
        stickyActionColumn
      />
    </Box>
  );
};
